import type React from "react";

import { ConfirmModal } from "@/components/ConfirmModal/ConfirmModal";
import { Stack } from "@/design-system/Stack";
import { useSessionUser } from "@/hooks/Network/useSessionUser";
import { servicePartnerMutations } from "@/queries/service-partners/mutations";
import { useTranslation } from "@/translations";

interface IqbiDetailsVerifyAddressModalProps {
  serviceId: string;
  isOpen: boolean;
  onClose: () => void;
}

export function IqbiDetailsVerifyAddressModal({
  serviceId,
  isOpen,
  onClose,
}: IqbiDetailsVerifyAddressModalProps): React.ReactNode {
  const { t } = useTranslation();
  const sessionUser = useSessionUser();

  const verifyIqbiAddressMutation = servicePartnerMutations.useVerifyIqbiAddress();

  return (
    <ConfirmModal
      tone="primary"
      title={t("page.service-details.iqbi.verify-modal.title")}
      isLoading={verifyIqbiAddressMutation.isPending}
      onResolve={() => {
        verifyIqbiAddressMutation.mutate(serviceId, {
          onSuccess: () => {
            onClose();
          },
        });
      }}
      onReject={onClose}
      resolveBtnProps={{
        text: t("page.service-details.iqbi.verify-modal.confirm-btn"),
      }}
      onOpenChange={(state) => {
        if (!state) {
          onClose();
        }
      }}
      rejectBtnProps={{
        text: t("page.service-details.iqbi.verify-modal.reject-btn"),
      }}
      isOpened={isOpen}
    >
      <Stack gap="md">
        <p className="text-center">{t("page.service-details.iqbi.verify-modal.description")}</p>
        <p className="text-center">
          {sessionUser.address ? (
            <>
              {sessionUser.address.location}
              <br />
              {sessionUser.address?.postalCode} {sessionUser.address?.city}
            </>
          ) : (
            sessionUser.company?.name
          )}
        </p>
      </Stack>
    </ConfirmModal>
  );
}
